<template>
  <div class="grid grid-cols-12 gap-x-10 mt-8 mb-5">
    <div class="col-span-12">
      <div class="flex items-center justify-between">
        <h5><i class="dot"></i>{{ $t('사업장 현황') }}</h5>
      </div>
      <vs-table class="table2 mt-5" v-model="selectedField" @selected="handleSelected" pagination :data="list">
        <template slot="thead">
          <vs-th> No.</vs-th>
          <vs-th>{{ $t('사업장명') }}</vs-th>
          <vs-th>{{ $t('담당 주무관') }}</vs-th>
          <vs-th>{{ $t('사업기간') }}</vs-th>
          <vs-th>{{ $t('사업금액') }}</vs-th>
          <vs-th>{{ $t('사업장 주소') }}</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td> {{ data[indextr].id }}</vs-td>
            <vs-td> {{ data[indextr].field_name }}</vs-td>
            <vs-td> {{ data[indextr].manager_name }}</vs-td>
            <vs-td> {{ getDate(data[indextr].work_begin_at) }} ~ {{ getDate(data[indextr].work_end_at) }}</vs-td>
            <vs-td> {{ data[indextr].deposit_amount }}</vs-td>
            <vs-td> {{ data[indextr].address }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>

    <!-- 사업장 세부 정보 -->
    <div v-if="showDetail" class="col-span-12">
      <div class="flex items-center justify-between">
        <h5><i class="dot"></i>{{ $t('사업장 세부 정보') }}</h5>
      </div>
      <div class="mt-5">
        <div class="grid grid-cols-12 gap-x-6 gap-y-4 items-start">
          <div class="col-span-4 flex items-center">
            <div class="label-text mr-4">{{ $t('사업장명') }}</div>
            <ml-input class="w-full flex-1" v-model="selectedField.field_name" :readonly="true"/>
          </div>
          <div class="col-span-4 flex items-center">
            <div class="label-text mr-4">{{ $t('담당 주무관') }}</div>
            <ml-input class="w-full flex-1" v-model="selectedField.manager_name" :readonly="true"/>
          </div>
          <div class="col-span-4 flex items-center">
            <div class="label-text mr-4">{{ $t('사업기간') }}</div>
            <div class="w-full flex flex-1">
              <date-selector v-model="selectedField.work_begin_at" :readonly="true" />
              <label class="px-2 flex" style="align-items: center">~</label>
              <date-selector v-model="selectedField.work_end_at" :readonly="true" />
            </div>
          </div>
          <div class="col-span-4 flex items-center">
            <div class="label-text mr-4">{{ $t('사업금액') }}</div>
            <ml-input class="w-full flex-1" v-model="selectedField.deposit_amount" :readonly="true"/>
          </div>
          <div class="col-span-4 flex items-center">
            <div class="label-text mr-4" style="word-break: keep-all;">{{ $t('사업장 주소 (행정동)') }}</div>
            <ml-input class="w-full flex-1" v-model="selectedField.address" :readonly="true"/>
          </div>
          <div class="col-span-4 flex items-center">
            <div class="label-text mr-4">{{ $t('사업장 연락처') }}</div>
            <ml-input class="w-full flex-1" v-model="selectedField.phone" :readonly="true"/>
          </div>
          <div class="col-span-4 flex items-center">
            <div class="label-text mr-4" style="word-break: keep-all;">{{ $t('원료·제조물 해당 법령') }}</div>
            <div class="w-full flex-1">
              <ml-input class="w-full flex-1" :value="selectedField.applicable_law" :readonly="true"/>
              <div style="color: #696d71;">{{ $t('※ 중처법 제8조제3호참고') }}</div>
            </div>


          </div>
          <div class="col-span-4 flex items-center">
            <div class="label-text mr-4">{{ $t('구체적 사용처') }}</div>
            <ml-input class="w-full flex-1" :value="selectedField.specific_uses" :readonly="true"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DateSelector from "@/components/selector/DateSelector";
export default {
  name: "WorkplaceMaterialCompanyList",
  components: { DateSelector },
  props: {
    list: Array,
    showDetail: Boolean,
  },
  data() {
    return {
      selectedField: {},
    };
  },
  methods: {
    getDate(date) {
      if (date) {
        return new Date(date).format("yyyy-MM-dd");
      }
      return "";
    },
    handleSelected(field) {
      this.$emit("select", field);
    },
    clearFieldInfo() {
      this.selectedField = {}
    }
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}

.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}

.upload-content {
  border: $border;

  &:last-child {
    border-left: none;
  }

  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }

  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
.table1::v-deep,
.table2::v-deep {
  th .vs-table-text {
    justify-content: center;
  }
  td {
    text-align: center;
  }
}
</style>
